import t, { useState as e, useEffect as r, useRef as n } from "react";

function o(t) {
  return (o = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function i(t, e) {
  return (i = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function u() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}

function s(t, e, r) {
  return (s = u() ? Reflect.construct : function (t, e, r) {
    var n = [null];
    n.push.apply(n, e);
    var o = new (Function.bind.apply(t, n))();
    return r && i(o, r.prototype), o;
  }).apply(null, arguments);
}

function c(t) {
  var e = "function" == typeof Map ? new Map() : void 0;
  return (c = function c(t) {
    if (null === t || -1 === Function.toString.call(t).indexOf("[native code]")) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== e) {
      if (e.has(t)) return e.get(t);
      e.set(t, r);
    }

    function r() {
      return s(t, arguments, o(this).constructor);
    }

    return r.prototype = Object.create(t.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), i(r, t);
  })(t);
}

function a(t) {
  var e = t.baseUrl,
      r = void 0 === e ? process.env.SITE_FOOTER_URL : e,
      n = t.siteSlug;
  if (!r) throw new Error("Missing either baseUrl prop or `SITE_FOOTER_URL` environment variable");
  r.endsWith("/") || (r += "/");
  var o = r + "fallback.html";
  return n ? {
    src: "" + r + n + "/v1.html",
    alt: o
  } : {
    src: o,
    alt: o
  };
}

var l = function l(t, e) {
  var r = (void 0 === e ? {} : e).baseUrl;

  try {
    var n,
        o = function o() {
      function t(t) {
        return {
          baseUrl: r,
          html: i,
          siteSlug: u,
          esi: !1
        };
      }

      var e = function () {
        if (n) return Promise.resolve(n(c || l)).then(function (t) {
          if (!t.ok) throw new f("Failed to fetch Site Footer", t);
          return Promise.resolve(t.text()).then(function (t) {
            i = t;
          });
        });
      }();

      return e && e.then ? e.then(t) : t();
    },
        i = "",
        u = function (t) {
      var e,
          r = t;

      if (r && r.startsWith("/")) {
        var n = r.split("/");
        n.length > 1 && (r = n[1]);
      }

      return function (t) {
        return !!t && p.test(t);
      }(r) || console.warn("Invalid site slug: " + r), null === (e = r) || void 0 === e ? void 0 : e.toLowerCase();
    }(t),
        s = a({
      siteSlug: u,
      baseUrl: r
    }),
        c = s.src,
        l = s.alt,
        d = function () {
      if ("undefined" != typeof fetch) n = fetch;else {
        var t = function () {
          if ("undefined" == typeof window) return Promise.resolve(import("node-fetch")).then(function (t) {
            n = t.default;
          });
          fail("Please include a fetch polyfill");
        }();

        if (t && t.then) return t.then(function () {});
      }
    }();

    return Promise.resolve(d && d.then ? d.then(o) : o());
  } catch (t) {
    return Promise.reject(t);
  }
},
    f = function (t) {
  var e, r;

  function n(e, r) {
    var o;
    return (o = t.call(this, e + " (" + r.status + " @ " + r.url + ")") || this).name = "SiteFooterError", o.status = r.status, o.url = r.url, Object.setPrototypeOf(function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }(o), n.prototype), o;
  }

  return r = t, (e = n).prototype = Object.create(r.prototype), e.prototype.constructor = e, e.__proto__ = r, n;
}(c(Error)),
    p = /^[a-zA-Z][a-zA-Z-]*[a-zA-Z]$/,
    d = function d(o) {
  var i = o.siteSlug,
      u = o.esi,
      s = void 0 === u ? "production" === process.env.NODE_ENV : u,
      c = o.baseUrl,
      f = function (t) {
    var n = t.siteSlug,
        o = t.baseUrl,
        i = t.esi,
        u = t.html,
        s = "";
    if ("undefined" == typeof window) if (i) {
      var c = a({
        siteSlug: n,
        baseUrl: o
      });
      s = '<esi:include src="' + c.src + '" alt="' + c.alt + '" onerror="continue" />';
    } else u && (s = u);
    var f = e({
      baseUrl: o,
      esi: i,
      html: s,
      siteSlug: n
    }),
        p = f[0],
        d = f[1];
    return r(function () {
      i || l(n, {
        baseUrl: o
      }).then(d);
    }, [n, o, i]), p;
  }({
    siteSlug: i,
    esi: s,
    baseUrl: void 0 === c ? process.env.SITE_FOOTER_URL : c,
    html: o.html
  }),
      p = function (t) {
    var e = n(null);
    return r(function () {
      if (t) {
        var r = document.getElementById("site-footer-embed");

        if (!r) {
          var n,
              o = null === (n = r = e.current) || void 0 === n ? void 0 : n.innerHTML.trim();
          if (o && !o.startsWith("<esi:include")) return;
        }

        if (r && "true" !== r.dataset.siteFooterInjected) {
          r.innerHTML = "";
          var i = document.createRange();
          i.setStart(r, 0), r.appendChild(i.createContextualFragment(t)), r.dataset.siteFooterInjected = "true";
        }
      }
    }, [t]), e;
  }(s ? void 0 : f.html);

  return t.createElement("div", {
    "data-site-footer-esi": s,
    "data-site-footer-site-slug": i,
    ref: p,
    suppressHydrationWarning: !0,
    dangerouslySetInnerHTML: {
      __html: f.html
    }
  });
};

export { d as SiteFooterEmbed, l as fetchSiteFooterProps };